import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";
import { CALCULATOR_LIST } from "../calculators";

const linkClass =
  "flex items-center gap-2.5 rounded-xl border border-border bg-card/40 px-4 py-3 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-primary/10";

/** Links to the hub (BMI) and the other health calculators. */
export function BmiRelated({ currentSlug }: { currentSlug?: string }) {
  const others = CALCULATOR_LIST.filter((c) => c.slug !== currentSlug);
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.bmi_related_title()}
      </h2>
      <div className="grid gap-3 sm:grid-cols-3">
        {currentSlug !== undefined && (
          <Link to="/bmi-calculator" className={linkClass}>
            <span aria-hidden>📊</span>
            <span>{m.bmi_nav_main()}</span>
          </Link>
        )}
        {others.map((c) => (
          <Link
            key={c.slug}
            to="/bmi-calculator/$calc"
            params={{ calc: c.slug }}
            className={linkClass}
          >
            <span aria-hidden>{c.icon}</span>
            <span>{c.navName()}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
